import { Routes } from '@angular/router';
import { authGuard } from '@tsin-core/guards/auth.guard';

export const routes: Routes = [
    // { path: '', redirectTo: '/account/validate-login', pathMatch: 'full' },
    { path: '', redirectTo: '/management', pathMatch: 'full' },
    { path: 'user', canActivate: [authGuard], loadChildren: () => import('./pages/user/user.routes') },
    { path: 'casual-staff', data: { preload: true }, loadChildren: () => import('./pages/staff/staff.routes') },
    { path: 'management', canActivate: [authGuard], data: { preload: true }, loadChildren: () => import('./pages/management/management.routes') },
    { path: 'account', data: { preload: true }, loadChildren: () => import('./pages/account/account.routes') },
    { path: '**', redirectTo: 'management' }
];
